import Vue from "vue";

export async function indexDamageBudgets(damage_claim_id) {
  const response = await Vue.prototype.$http.get(
    `/damage_claims/${damage_claim_id}/budgets`
  );

  return response.data;
}

export async function storeProductBudget(claim_id, payload) {
  const response = await Vue.prototype.$http.post(
    `damage_claims/${claim_id}/product_budgets`,
    payload
  );

  return response.data;
}

export async function updateProductBudget(claim_id, budget_id, payload) {
  const response = await Vue.prototype.$http.put(
    `damage_claims/${claim_id}/product_budgets/${budget_id}`,
    payload
  );

  return response.data;
}

export async function approveProductBudget(claim_id, budget_id, payload) {
  const response = await Vue.prototype.$http.put(
    `damage_claims/${claim_id}/product_budgets/${budget_id}/approve`,
    payload
  );

  return response.data;
}

export async function deleteProductBudget(claim_id, budget_id) {
  const response = await Vue.prototype.$http.delete(
    `damage_claims/${claim_id}/product_budgets/${budget_id}`
  );

  return response;
}

export async function storeRoomBudget(claim_id, payload) {
  const response = await Vue.prototype.$http.post(
    `damage_claims/${claim_id}/room_budgets`,
    payload
  );

  return response.data;
}

export async function updateRoomBudget(claim_id, budget_id, payload) {
  const response = await Vue.prototype.$http.put(
    `damage_claims/${claim_id}/room_budgets/${budget_id}`,
    payload
  );

  return response.data;
}

export async function approveRoomBudget(claim_id, budget_id, payload) {
  const response = await Vue.prototype.$http.put(
    `damage_claims/${claim_id}/room_budgets/${budget_id}/approve`,
    payload
  );

  return response.data;
}

export async function deleteRoomBudget(claim_id, budget_id) {
  const response = await Vue.prototype.$http.delete(
    `damage_claims/${claim_id}/room_budgets/${budget_id}`
  );

  return response;
}

export function calcRoomBudget(budget) {
  const forfait_price = Number(budget.forfait_price) || 0;
  const material_price = Number(budget.material_price) || 0;
  const quantity = Number(budget.quantity) || 0;

  return forfait_price * quantity + material_price;
}
